import { TFunction } from 'i18next'

import { TestRunStates } from '../models/hardware-tests.model'

export const getHardwareTestStatus = (state: TestRunStates, t: TFunction): string => t(`system-details.hardware-tests.table.states.${state}`)
